import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Icon } from 'antd'

import { categoryType } from '@texts/categories'

import { categories } from '@services/api'

@inject((store: any) => {
    const { popupStore, categoriesStore } = store
    return { popupStore, categoriesStore }
})
@observer
export default class List extends Component<any, any> {
    handleRemoveRef = async (e, id) => {
        const { popupStore, categoriesStore } = this.props
        e.preventDefault()
        categories
            .deleteRef(id)
            .then(async res => {
                await categoriesStore.getRelatedCategories(popupStore.info.id)
                this.props.error()
            })
            .catch(e => this.props.error('serverError', 'קיימת בעיה בהסרת השיוך'))
    }
    render() {
        return (
            <Fragment>
                <div
                    style={{
                        display: 'inline-block',
                        width: '100%',
                        padding: '0.8rem',
                        backgroundColor: '#f2f2f2',
                        marginTop: '0.5rem'
                    }}
                >
                    {this.props.title ? (
                        <strong style={{ width: '100%', display: 'block', marginBottom: '0.5rem' }}>
                            {this.props.title}
                        </strong>
                    ) : (
                        ''
                    )}
                    <div style={{ maxHeight: '150px', overflow: 'auto' }}>
                        {this.props.list.length > 0
                            ? this.props.list.map((cat, index) => (
                                  <div
                                      key={index}
                                      style={{ backgroundColor: 'white', padding: '0.5rem', marginBottom: '1px' }}
                                  >
                                      <span style={{ maxWidth: '80%', display: 'inline-block' }}>
                                          <strong>{cat.name}</strong> | מזהה: {cat.id} | סוג: {categoryType[cat.type]}
                                      </span>
                                      <a onClick={e => this.handleRemoveRef(e, cat.ref_id)} style={{ float: 'left' }}>
                                          <Icon type="delete" /> הסר
                                      </a>
                                  </div>
                              ))
                            : 'לא נמצאו קטגוריות'}
                    </div>
                </div>
            </Fragment>
        )
    }
}
